<template>
  <div>
    <div class="subnavbackground">
      <SavedSearches 
        application="tv-analys" 
        :tabName="$route.meta.tab" 
        :currentFilters="$store.getters[`get${$route.meta.tabQuery}Query`]"
        :isExpanded="expandSavedSearchesSidebar"
        @close="$store.commit('systemInfo/updateExpandSavedSearchesSidebar', false)"
      />
      <b-row
        v-if="obsMessage"
        class="obs-message-row"
      >
        <p class="obsText">
          {{ obsMessage }}
        </p>
      </b-row>
      <b-row class="bottomheader mr-0">
        <button
          id="tooltip-target-ssasinfo"
          class="this-tool-icon-container clientinfotv"
        >
          <img
            class="this-tool-icon d-block"
            src="../../../assets/images/online-blue.svg"
            alt=""
          >
        </button>
        <div
          v-if="userInternalText()"
          class="userinternaltext"
        >
          {{ userInternalText() }} &#x1F441;
        </div>
        <b-tooltip
          v-if="SSASMessage != null || config_CurrentClientVersion != null"
          target="tooltip-target-ssasinfo"
          triggers="hover"
          custom-class="infoTooltip"
        >
          <p>Client version: {{ config_CurrentClientVersion }}</p>
          <p>API version: {{ SSASMessage.version }}</p>
          <p>Model: {{ SSASMessage.linkedSSAS }}</p>
          <p>Latest AAM import: {{ SSASMessage.lastImported }}</p>
          <p>Latest SSAS processing: {{ SSASMessage.lastProcessed }}</p>
          <p>Last panel day: {{ SSASMessage.latestDay }}</p>
          <p>First publication day: {{ SSASMessage.publishedFromDate }}</p>
          <p>Last publication day: {{ SSASMessage.publishedToDate }}</p>
          <p>First publication day ad: {{ SSASMessage.adPublishedFromDate }}</p>
        </b-tooltip>
        <div class="center">
          <router-link
            v-if="this.$store.state.systemInfo.lightAccess || this.$store.state.systemInfo.fullAccess"
            to="/toplist"
          >
            Top list
          </router-link>
          <router-link
            v-if="this.$store.state.systemInfo.fullAccess"
            to="/programs"
          >
            Program
          </router-link>
          <router-link
            v-if="(config_ShowCampaignTab && this.$store.state.systemInfo.fullAccess) || (config_ShowCampaignTab && this.$store.state.systemInfo.advertiserAccess)"
            to="/campaigns"
          >
            Ad
          </router-link>
          <router-link
            v-if="this.$store.state.systemInfo.fullAccess"
            to="/site"
          >
            Site
          </router-link>
        </div>
        <div
          v-if="anyFormFieldsLoaded"
          class="right"
        >
          <b-button 
            class="savesearchbtn px-2" 
            variant="primary" 
            id="tooltip-target-1" 
            @click="$store.commit('systemInfo/updateExpandSavedSearchesSidebar', true)"
            v-if="showSaveSearchButton"
          >
            <i class="bi bi-floppy"></i>
          </b-button>
          <b-tooltip target="tooltip-target-1" triggers="hover">
            Save/load template
          </b-tooltip>
          <b-button
            id="infoButton"
            v-b-toggle.sidebar-1
            class="btn-xs mx-2"
            variant="primary"
          >
            <b-icon icon="info-circle" />
          </b-button>
          <b-tooltip
            target="infoButton"
            triggers="hover"
            placement="top"
          >
            View information log
          </b-tooltip>
        
          <b-button
            id="bookButton"
            class="btn-xs"
            variant="info"
            @click="openInfoLink"
          >
            <b-icon icon="book" />
            <span />
          </b-button>
          <b-tooltip
            target="bookButton"
            triggers="hover"
            placement="top"
          >
            Read user manual
          </b-tooltip>
        </div>
      </b-row>
    </div>
    <b-sidebar
      id="sidebar-1"
      right
      title="Information log"
      shadow
    >
      <div class="px-3 py-2">
        <p
          class="messageBox"
          v-html="dataLogMessage"
        />
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import SavedSearches from "./SavedSearches"; 

export default {
  name: 'SubNav',
  components: {
    SavedSearches,
  },
  computed: {
    showSaveSearchButton() {
      return this.$store.getters["systemInfo/getShowSaveSearchButton"];
    },
    expandSavedSearchesSidebar: {
      get() {
        return this.$store.getters["systemInfo/getExpandSavedSearchesSidebar"]
      },
      set(value) {
        this.$store.commit('systemInfo/updateExpandSavedSearchesSidebar', value);
      }
    },
    dataLogMessage() {
      return this.$store.getters["systemInfo/getDataLogMessage"];
    },
    obsMessage() {
      return this.$store.getters["systemInfo/getObsMessage"];
    },
    SSASMessage() {
      return this.$store.state.systemInfo.ssasInfo
    },
    anyFormFieldsLoaded(){
      let anyFormFieldsLoaded = false
      if(this.$store.getters["systemInfo/getAnyFormFieldsLoaded"])
        anyFormFieldsLoaded = true
      return anyFormFieldsLoaded
    },
    environment() {
      const heading = (this.applicationHeading || "").toLowerCase();
      if (heading.includes(" dev")) {
        return "DEV";
      } else if (heading.includes(" test")) {
        return "TEST";
      } else if (heading.includes(" local")) {
        return "LOCAL";
      }
      return "";
    }
  },
  watch: {
  $route(to) {

    this.$store.commit('systemInfo/updateExpandSavedSearchesSidebar', false);
    const tabMap = {
      '/toplist': 'Toplist',
      '/programs': 'Programs',
      '/campaigns': 'Campaigns',
      '/site': 'Site',
    };
    const activeTab = tabMap[to.path] || null;
    if(activeTab == "Toplist")
      this.$store.commit('systemInfo/updateShowSaveSearchButton', false);
    else
      this.$store.commit('systemInfo/updateShowSaveSearchButton', true);
    this.$store.commit(
      'systemInfo/updateActiveTab',
      activeTab,
    );
  },
},
  methods: {
    userInternalText(){
      let userInternalText = "";
      if(this.$store.state.systemInfo.internalAndMMSOnly)
        userInternalText = "MMS-ONLY"
      return userInternalText;
    },
    openInfoLink() {
      window.open('https://mms.se/wp-content/uploads/manual-online-analys.pdf', '_blank');
    }
  }
};
</script>

<style scoped>
.savesearchbtn {
  padding-top: .1rem;
  padding-bottom: 0;
}
.messageBox {
  border: 1px solid #dee2e6 !important;
  background-color: #eee;
  margin-bottom: 0;
  padding: 10px;
  font-size: small;
  color: #2c3e50 !important;
  text-align: left;
  white-space: pre-line;
}
.this-tool-icon-container {
    display: inline-block;
    flex: 1;
    height: 100%;
    width: 2.4rem;
    margin-left: 1rem;
    margin-top: 0;
    max-width: 2.5rem;
    max-height: 2.5rem;
}
img.this-tool-icon {
  max-width: 1.5rem;
  max-height: 1.5rem;
  margin-left: 0.2rem;
  margin-right: 0.4rem;
  padding: 0;
}
>>> .userinternaltext{
  display: flex;
  justify-content: center;
  flex-direction: column;
  color: red;
  position: absolute;
  margin-left: 3.6rem;
}
.btn-xs {
  padding: 0.25rem 0.4rem;
  font-size: 0.875rem;
  line-height: 0.5;
  border-radius: 0.2rem;
}
.clientinfotv{
  flex: 0 0 auto;
  background: none;
  border: none;
  padding: 0;
  cursor: default;
  position: absolute;
}
.center{
  margin: 0 auto;
}
.right{
  flex: 0 0 auto;
  margin-right: 1rem;
  position: absolute;
  right: 1rem;
}
a {
  text-transform: uppercase;
  margin: 5px 20px;
  position: relative;
  display: inline-block;
  color: #337ab7;
}
.router-link-exact-active {
  font-weight: bold;
}
.subnavbackground {
  height: auto;
}
.infoTooltip {
  position: relative;
  padding: 0;
  margin-right: 3rem;
  align-self: center;
  display: inline-block;
  align-content: center;
}
::v-deep .tooltip-inner {
  max-width: none !important;
  font-size: smaller;
  text-align: left;
}
.obs-message-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px 0 16px;
  flex-grow: 1;
  background-color: #fff;
  border-bottom: 1px solid #225380;
  flex-wrap: nowrap;
  margin-right: 0;
}
.bottomheader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    border-bottom: 1px dotted #aaa;
    height: 40px !important;
    padding: 5px 16px;
    position: relative;
    flex-wrap: wrap;
}
.obsText {
    margin-left: 18px;
    margin-bottom: 0;
    padding: 5px 0;
    letter-spacing: .25px;
    color: #ff8c00;
    font-size: .9em;
    flex-grow: 1;
    overflow-wrap: break-word;
    text-align: center;
}
</style>
